import UncontrolledPopover from 'components/SafeUncontrolledPopover';

import { FC, useRef } from 'react';
import { Col } from 'reactstrap';
import { PrivateDataBadge } from '../components/PrivateDataBadge';

export const NestedPerformanceHeaderBox: FC<{
  id?: string;
  title: string | object;
  helperText?: any;
  private?: boolean;
  body: any;
  width?: string;
}> = (props) => {
  const popoverTargetRef = useRef(null);

  return (
    <Col className={'col pe-0 ' + props.width || ''}>
      {props.title && (
        <h6 className="text-uppercase text-secondary mb-3">
          {props.title}
          {props.helperText && (
            <>
              <i
                ref={popoverTargetRef}
                className="ms-1 fe fe-help-circle text-primary"
              />
              <UncontrolledPopover
                placement="top"
                trigger="hover"
                target={popoverTargetRef}
              >
                {props.helperText}
              </UncontrolledPopover>
            </>
          )}
          {props.private && <PrivateDataBadge />}
        </h6>
      )}
      {props.body}
    </Col>
  );
};
